import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CSEService } from '../../services/cse.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { CarrierEquipment, TrailerType } from '../../models/models';

@Component({
    selector: 'carrier-equipment-form',
    templateUrl: './carrier-equipment-form.component.html',
    standalone: false
})
export class CarrierEquipmentForm implements OnChanges {
    @Input() carrierEquipmentID: number = 0;
    @Input() carrierID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public carrierEquipment: CarrierEquipment = {} as CarrierEquipment;
    public trailerTypeList: TrailerType[] = [];
    //public commentText: string = "";
    public isAddContact: boolean = false;
    public isEditContact: boolean = false;
    public isExpectedCloseDateValid: boolean = true;
    public isLoading: boolean = false;

    constructor(private cseService: CSEService, private notificationService: NotificationService,
        private orderService: OrderService) {
    }

    ngOnInit() {
        this.getTrailerTypes();
        //console.log("ngOnInit", this.opportunityID, this.carrierID);
    }

    ngOnChanges() {
        this.getCarrierEquipment();
        //console.log("ngOnChanges", this.opportunity);
    }

    private getTrailerTypes() {
        this.orderService.getTrailerTypes().subscribe(result => {
            this.trailerTypeList = result;
        });
    }

    private getCarrierEquipment() {
        if (this.carrierEquipmentID > 0) {
            this.isLoading = true;
            this.cseService.getCarrierEquipmentByID(this.carrierEquipmentID).subscribe(result => {
                this.isLoading = false;
                if (result.resultCollection.length > 0) {
                    this.carrierEquipment = result.resultCollection[0];
                }
            });
        }
        else {
            this.carrierEquipment = {
                carrierEquipmentID: 0,
                carrierID: this.carrierID,
                trailerTypeID: 0,
                equipmentCount: 0,
                trailerLength: 0
            } as CarrierEquipment;
        }
    }

    public save() {
        this.isLoading = true;
        console.log("save:before", this.carrierEquipment);
        this.cseService.saveCarrierEquipment(this.carrierEquipment).subscribe(result => {
            this.isLoading = false;
            console.log("save:after", result);
            this.onRefresh.emit();
        });

        this.carrierEquipment = {} as CarrierEquipment;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
